




import { Component, Vue } from 'vue-property-decorator';
import parameterSettings from '@/components/parameters/parameter-settings.component.vue'; // パラメータ管理

@Component({
  components: {
    'parameter-settings': parameterSettings
  }
})
export default class List extends Vue {}
